<template>
  <div class="settings-button-wrap group">
    <em
      class="custom-icons group-hover:bg-icon-hover"
      :class="{ disabled: pageNotFound || isNewBoard }"
      :style="[getCustomIconStyle(iconPath('more-horizontal'))]"
    />
  </div>
</template>

<script>
import pageNotFound from '@/mixins/pageNotFound';
import useCustomIcon from '@/utilities/composables/useCustomIcon';

export default {
  name: 'SettingsButtonHomeHeader',
  mixins: [pageNotFound],
  setup() {
    const { iconPath, getCustomIconStyle } = useCustomIcon();

    return { iconPath, getCustomIconStyle };
  },
  computed: {
    isNewBoard() {
      return this.$route.name === 'newboard';
    },
  },
};
</script>

<style lang="scss">
.settings-button-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;

  .custom-icons {
    @apply h-5 w-5;
  }
}
</style>
